// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v3.21.12
// source: villa.proto

/* eslint-disable */
import { Timestamp } from "./google/protobuf/timestamp";
import { Location } from "./location";
import { RoomVilla } from "./room_villa";

export const protobufPackage = "usertracking.v3";

export interface Villa {
  date_from: Date | undefined;
  date_to: Date | undefined;
  passenger_no: number;
  region: string;
  region_id: string;
  utm_source: string;
  sort: string;
  property_name: string;
  price: number;
  booking_id: number;
  payment_gateway: string;
  amount: number;
  discount_code: string;
  error: string;
  discount: number;
  payment_success: boolean;
  city: string;
  city_id: number;
  hotel: string;
  hotel_id: number;
  price_off: number;
  discount_percent: number;
  is_available: boolean;
  rooms: RoomVilla[];
  eligible_payment_gateways: string[];
  available_hotels_id: number[];
  page: number;
  blue_box_loaded: number;
  count_of_blue_box_cards: number;
  last_minute_loaded: number;
  gateway: string;
  basket_price: number;
  ycard_balance: number;
  penny_balance: number;
  provider: string;
  property_id: string;
  user_location: Location | undefined;
  initial_zoom_level: number;
  listings_count: number;
  viewport_change_type: string;
  new_center_coords: Location | undefined;
  visible_listings_count: number;
  accommodation_id: number;
  position: number;
  click_area: string;
  stay_duration_days: number;
  removed_filter_name: string;
  current_map_center: Location | undefined;
  current_zoom_level: number;
  new_view_state: string;
  value: number;
  time_ms_spent?: number
}

function createBaseVilla(): Villa {
  return {
    date_from: undefined,
    date_to: undefined,
    passenger_no: 0,
    region: "",
    region_id: "",
    utm_source: "",
    sort: "",
    property_name: "",
    price: 0,
    booking_id: 0,
    payment_gateway: "",
    amount: 0,
    discount_code: "",
    error: "",
    discount: 0,
    payment_success: false,
    city: "",
    city_id: 0,
    hotel: "",
    hotel_id: 0,
    price_off: 0,
    discount_percent: 0,
    is_available: false,
    rooms: [],
    eligible_payment_gateways: [],
    available_hotels_id: [],
    page: 0,
    blue_box_loaded: 0,
    count_of_blue_box_cards: 0,
    last_minute_loaded: 0,
    gateway: "",
    basket_price: 0,
    ycard_balance: 0,
    penny_balance: 0,
    provider: "",
    property_id: "0",
    user_location: undefined,
    initial_zoom_level: 0,
    listings_count: 0,
    viewport_change_type: "",
    new_center_coords: undefined,
    visible_listings_count: 0,
    accommodation_id: 0,
    position: 0,
    click_area: "",
    stay_duration_days: 0,
    removed_filter_name: "",
    current_map_center: undefined,
    current_zoom_level: 0,
    new_view_state: "",
    value: 0,
  };
}

export const Villa: MessageFns<Villa> = {
  fromJSON(object: any): Villa {
    return {
      date_from: isSet(object.date_from) ? fromJsonTimestamp(object.date_from) : undefined,
      date_to: isSet(object.date_to) ? fromJsonTimestamp(object.date_to) : undefined,
      passenger_no: isSet(object.passenger_no) ? globalThis.Number(object.passenger_no) : 0,
      region: isSet(object.region) ? globalThis.String(object.region) : "",
      region_id: isSet(object.region_id) ? globalThis.String(object.region_id) : "",
      utm_source: isSet(object.utm_source) ? globalThis.String(object.utm_source) : "",
      sort: isSet(object.sort) ? globalThis.String(object.sort) : "",
      property_name: isSet(object.property_name) ? globalThis.String(object.property_name) : "",
      price: isSet(object.price) ? globalThis.Number(object.price) : 0,
      booking_id: isSet(object.booking_id) ? globalThis.Number(object.booking_id) : 0,
      payment_gateway: isSet(object.payment_gateway) ? globalThis.String(object.payment_gateway) : "",
      amount: isSet(object.amount) ? globalThis.Number(object.amount) : 0,
      discount_code: isSet(object.discount_code) ? globalThis.String(object.discount_code) : "",
      error: isSet(object.error) ? globalThis.String(object.error) : "",
      discount: isSet(object.discount) ? globalThis.Number(object.discount) : 0,
      payment_success: isSet(object.payment_success) ? globalThis.Boolean(object.payment_success) : false,
      city: isSet(object.city) ? globalThis.String(object.city) : "",
      city_id: isSet(object.city_id) ? globalThis.Number(object.city_id) : 0,
      hotel: isSet(object.hotel) ? globalThis.String(object.hotel) : "",
      hotel_id: isSet(object.hotel_id) ? globalThis.Number(object.hotel_id) : 0,
      price_off: isSet(object.price_off) ? globalThis.Number(object.price_off) : 0,
      discount_percent: isSet(object.discount_percent) ? globalThis.Number(object.discount_percent) : 0,
      is_available: isSet(object.is_available) ? globalThis.Boolean(object.is_available) : false,
      rooms: globalThis.Array.isArray(object?.rooms) ? object.rooms.map((e: any) => RoomVilla.fromJSON(e)) : [],
      eligible_payment_gateways: globalThis.Array.isArray(object?.eligible_payment_gateways)
        ? object.eligible_payment_gateways.map((e: any) => globalThis.String(e))
        : [],
      available_hotels_id: globalThis.Array.isArray(object?.available_hotels_id)
        ? object.available_hotels_id.map((e: any) => globalThis.Number(e))
        : [],
      page: isSet(object.page) ? globalThis.Number(object.page) : 0,
      blue_box_loaded: isSet(object.blue_box_loaded) ? globalThis.Number(object.blue_box_loaded) : 0,
      count_of_blue_box_cards: isSet(object.count_of_blue_box_cards)
        ? globalThis.Number(object.count_of_blue_box_cards)
        : 0,
      last_minute_loaded: isSet(object.last_minute_loaded) ? globalThis.Number(object.last_minute_loaded) : 0,
      gateway: isSet(object.gateway) ? globalThis.String(object.gateway) : "",
      basket_price: isSet(object.basket_price) ? globalThis.Number(object.basket_price) : 0,
      ycard_balance: isSet(object.ycard_balance) ? globalThis.Number(object.ycard_balance) : 0,
      penny_balance: isSet(object.penny_balance) ? globalThis.Number(object.penny_balance) : 0,
      provider: isSet(object.provider) ? globalThis.String(object.provider) : "",
      property_id: isSet(object.property_id) ? globalThis.String(object.property_id) : "0",
      user_location: isSet(object.user_location) ? Location.fromJSON(object.user_location) : undefined,
      initial_zoom_level: isSet(object.initial_zoom_level) ? globalThis.Number(object.initial_zoom_level) : 0,
      listings_count: isSet(object.listings_count) ? globalThis.Number(object.listings_count) : 0,
      viewport_change_type: isSet(object.viewport_change_type) ? globalThis.String(object.viewport_change_type) : "",
      new_center_coords: isSet(object.new_center_coords) ? Location.fromJSON(object.new_center_coords) : undefined,
      visible_listings_count: isSet(object.visible_listings_count)
        ? globalThis.Number(object.visible_listings_count)
        : 0,
      accommodation_id: isSet(object.accommodation_id) ? globalThis.Number(object.accommodation_id) : 0,
      position: isSet(object.position) ? globalThis.Number(object.position) : 0,
      click_area: isSet(object.click_area) ? globalThis.String(object.click_area) : "",
      stay_duration_days: isSet(object.stay_duration_days) ? globalThis.Number(object.stay_duration_days) : 0,
      removed_filter_name: isSet(object.removed_filter_name) ? globalThis.String(object.removed_filter_name) : "",
      current_map_center: isSet(object.current_map_center) ? Location.fromJSON(object.current_map_center) : undefined,
      current_zoom_level: isSet(object.current_zoom_level) ? globalThis.Number(object.current_zoom_level) : 0,
      new_view_state: isSet(object.new_view_state) ? globalThis.String(object.new_view_state) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: Villa): unknown {
    const obj: any = {};
    if (message.date_from !== undefined) {
      obj.date_from = message.date_from.toISOString();
    }
    if (message.date_to !== undefined) {
      obj.date_to = message.date_to.toISOString();
    }
    if (message.passenger_no !== 0) {
      obj.passenger_no = Math.round(message.passenger_no);
    }
    if (message.region !== "") {
      obj.region = message.region;
    }
    if (message.region_id !== "") {
      obj.region_id = message.region_id;
    }
    if (message.utm_source !== "") {
      obj.utm_source = message.utm_source;
    }
    if (message.sort !== "") {
      obj.sort = message.sort;
    }
    if (message.property_name !== "") {
      obj.property_name = message.property_name;
    }
    if (message.price !== 0) {
      obj.price = Math.round(message.price);
    }
    if (message.booking_id !== 0) {
      obj.booking_id = Math.round(message.booking_id);
    }
    if (message.payment_gateway !== "") {
      obj.payment_gateway = message.payment_gateway;
    }
    if (message.amount !== 0) {
      obj.amount = Math.round(message.amount);
    }
    if (message.discount_code !== "") {
      obj.discount_code = message.discount_code;
    }
    if (message.error !== "") {
      obj.error = message.error;
    }
    if (message.discount !== 0) {
      obj.discount = Math.round(message.discount);
    }
    if (message.payment_success !== false) {
      obj.payment_success = message.payment_success;
    }
    if (message.city !== "") {
      obj.city = message.city;
    }
    if (message.city_id !== 0) {
      obj.city_id = Math.round(message.city_id);
    }
    if (message.hotel !== "") {
      obj.hotel = message.hotel;
    }
    if (message.hotel_id !== 0) {
      obj.hotel_id = Math.round(message.hotel_id);
    }
    if (message.price_off !== 0) {
      obj.price_off = Math.round(message.price_off);
    }
    if (message.discount_percent !== 0) {
      obj.discount_percent = Math.round(message.discount_percent);
    }
    if (message.is_available !== false) {
      obj.is_available = message.is_available;
    }
    if (message.rooms?.length) {
      obj.rooms = message.rooms.map((e) => RoomVilla.toJSON(e));
    }
    if (message.eligible_payment_gateways?.length) {
      obj.eligible_payment_gateways = message.eligible_payment_gateways;
    }
    if (message.available_hotels_id?.length) {
      obj.available_hotels_id = message.available_hotels_id.map((e) => Math.round(e));
    }
    if (message.page !== 0) {
      obj.page = Math.round(message.page);
    }
    if (message.blue_box_loaded !== 0) {
      obj.blue_box_loaded = Math.round(message.blue_box_loaded);
    }
    if (message.count_of_blue_box_cards !== 0) {
      obj.count_of_blue_box_cards = Math.round(message.count_of_blue_box_cards);
    }
    if (message.last_minute_loaded !== 0) {
      obj.last_minute_loaded = Math.round(message.last_minute_loaded);
    }
    if (message.gateway !== "") {
      obj.gateway = message.gateway;
    }
    if (message.basket_price !== 0) {
      obj.basket_price = Math.round(message.basket_price);
    }
    if (message.ycard_balance !== 0) {
      obj.ycard_balance = Math.round(message.ycard_balance);
    }
    if (message.penny_balance !== 0) {
      obj.penny_balance = Math.round(message.penny_balance);
    }
    if (message.provider !== "") {
      obj.provider = message.provider;
    }
    if (message.property_id !== "0") {
      obj.property_id = message.property_id;
    }
    if (message.user_location !== undefined) {
      obj.user_location = Location.toJSON(message.user_location);
    }
    if (message.initial_zoom_level !== 0) {
      obj.initial_zoom_level = Math.round(message.initial_zoom_level);
    }
    if (message.listings_count !== 0) {
      obj.listings_count = Math.round(message.listings_count);
    }
    if (message.viewport_change_type !== "") {
      obj.viewport_change_type = message.viewport_change_type;
    }
    if (message.new_center_coords !== undefined) {
      obj.new_center_coords = Location.toJSON(message.new_center_coords);
    }
    if (message.visible_listings_count !== 0) {
      obj.visible_listings_count = Math.round(message.visible_listings_count);
    }
    if (message.accommodation_id !== 0) {
      obj.accommodation_id = Math.round(message.accommodation_id);
    }
    if (message.position !== 0) {
      obj.position = Math.round(message.position);
    }
    if (message.click_area !== "") {
      obj.click_area = message.click_area;
    }
    if (message.stay_duration_days !== 0) {
      obj.stay_duration_days = Math.round(message.stay_duration_days);
    }
    if (message.removed_filter_name !== "") {
      obj.removed_filter_name = message.removed_filter_name;
    }
    if (message.current_map_center !== undefined) {
      obj.current_map_center = Location.toJSON(message.current_map_center);
    }
    if (message.current_zoom_level !== 0) {
      obj.current_zoom_level = Math.round(message.current_zoom_level);
    }
    if (message.new_view_state !== "") {
      obj.new_view_state = message.new_view_state;
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create(base?: DeepPartial<Villa>): Villa {
    return Villa.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Villa>): Villa {
    const message = createBaseVilla();
    message.date_from = object.date_from ?? undefined;
    message.date_to = object.date_to ?? undefined;
    message.passenger_no = object.passenger_no ?? 0;
    message.region = object.region ?? "";
    message.region_id = object.region_id ?? "";
    message.utm_source = object.utm_source ?? "";
    message.sort = object.sort ?? "";
    message.property_name = object.property_name ?? "";
    message.price = object.price ?? 0;
    message.booking_id = object.booking_id ?? 0;
    message.payment_gateway = object.payment_gateway ?? "";
    message.amount = object.amount ?? 0;
    message.discount_code = object.discount_code ?? "";
    message.error = object.error ?? "";
    message.discount = object.discount ?? 0;
    message.payment_success = object.payment_success ?? false;
    message.city = object.city ?? "";
    message.city_id = object.city_id ?? 0;
    message.hotel = object.hotel ?? "";
    message.hotel_id = object.hotel_id ?? 0;
    message.price_off = object.price_off ?? 0;
    message.discount_percent = object.discount_percent ?? 0;
    message.is_available = object.is_available ?? false;
    message.rooms = object.rooms?.map((e) => RoomVilla.fromPartial(e)) || [];
    message.eligible_payment_gateways = object.eligible_payment_gateways?.map((e) => e) || [];
    message.available_hotels_id = object.available_hotels_id?.map((e) => e) || [];
    message.page = object.page ?? 0;
    message.blue_box_loaded = object.blue_box_loaded ?? 0;
    message.count_of_blue_box_cards = object.count_of_blue_box_cards ?? 0;
    message.last_minute_loaded = object.last_minute_loaded ?? 0;
    message.gateway = object.gateway ?? "";
    message.basket_price = object.basket_price ?? 0;
    message.ycard_balance = object.ycard_balance ?? 0;
    message.penny_balance = object.penny_balance ?? 0;
    message.provider = object.provider ?? "";
    message.property_id = object.property_id ?? "0";
    message.user_location = (object.user_location !== undefined && object.user_location !== null)
      ? Location.fromPartial(object.user_location)
      : undefined;
    message.initial_zoom_level = object.initial_zoom_level ?? 0;
    message.listings_count = object.listings_count ?? 0;
    message.viewport_change_type = object.viewport_change_type ?? "";
    message.new_center_coords = (object.new_center_coords !== undefined && object.new_center_coords !== null)
      ? Location.fromPartial(object.new_center_coords)
      : undefined;
    message.visible_listings_count = object.visible_listings_count ?? 0;
    message.accommodation_id = object.accommodation_id ?? 0;
    message.position = object.position ?? 0;
    message.click_area = object.click_area ?? "";
    message.stay_duration_days = object.stay_duration_days ?? 0;
    message.removed_filter_name = object.removed_filter_name ?? "";
    message.current_map_center = (object.current_map_center !== undefined && object.current_map_center !== null)
      ? Location.fromPartial(object.current_map_center)
      : undefined;
    message.current_zoom_level = object.current_zoom_level ?? 0;
    message.new_view_state = object.new_view_state ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function fromTimestamp(t: Timestamp): Date {
  let millis = (globalThis.Number(t.seconds) || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
